<template>
  <footer class="mt-auto py-4 px-4 border-t border-gray-200 dark:border-gray-700 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm w-full">
    <div class="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 w-full relative">
      <!-- Copyright - Centré -->
      <div class="text-xs sm:text-sm text-gray-600 dark:text-gray-400 text-center flex-1 sm:absolute sm:left-1/2 sm:transform sm:-translate-x-1/2">
        &copy; {{ currentYear }} K&C Madin Invest - Tous droits réservés
      </div>
      
      <!-- Mentions légales - À droite -->
      <div class="sm:absolute sm:right-4">
        <button
          @click="openLegalModal"
          class="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors cursor-pointer underline"
        >
          Mentions légales
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AuthFooter',
  emits: ['open-legal'],
  setup(props, { emit }) {
    const currentYear = ref(new Date().getFullYear())
    
    const openLegalModal = () => {
      emit('open-legal')
    }
    
    return {
      currentYear,
      openLegalModal
    }
  }
})
</script>

<style scoped>
footer {
  width: 100%;
}
</style>

